import {Sidebar} from "primereact/sidebar";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {useState} from "react";
import {Leaderboard} from "../data/leaderboard";
import {Entry} from "../data/entry";
import {InputNumber} from "primereact/inputnumber";

interface EntryEditSidebarProps {
    visible: boolean;
    onHide: () => void;
    leaderboard: Leaderboard;
    onSave: (updatedEntry: Entry) => void;
}

function EntryEditSidebar(
    {
        visible,
        onHide,
        leaderboard,
        onSave,
    }: EntryEditSidebarProps) {
    const [entry, setEntry] = useState<Entry>({...new Entry(), leaderboardId: leaderboard.id});

    const handleSave = () => {
        onSave(entry);
        setEntry({...new Entry(), leaderboardId: leaderboard.id});
    };

    return (
        <Sidebar
            visible={visible}
            onHide={onHide}
            header="Edit Leaderboard"
            position="right"
            style={{width: "30rem"}}
        >
            <div className="p-fluid">
                <div className="field">
                    <label htmlFor="name">Username</label>
                    <InputText
                        id="name"
                        value={entry.username}
                        maxLength={128}
                        onChange={(e) => setEntry({...entry, username: e.target.value,})
                        }
                    />
                </div>
                <div className="field">
                    <label htmlFor="score">Score</label>
                    <InputNumber
                        id="score"
                        value={entry.score}
                        showButtons={true}
                        onChange={(e) => setEntry({...entry, score: e.value ?? 0})}
                        maxFractionDigits={0}
                        className="w-full"/>
                </div>
                <div className="field">
                    <label htmlFor="meta">Meta</label>
                    <InputText
                        id="meta"
                        value={entry.meta}
                        maxLength={128}
                        onChange={(e) => setEntry({...entry, meta: e.target.value,})
                        }
                    />
                </div>
                <Button
                    label="Speichern"
                    icon="pi pi-check"
                    onClick={handleSave}
                    className="mt-3"
                />
            </div>
        </Sidebar>
    );
}

export default EntryEditSidebar;
